export default __webpack_public_path__ + "static/media/white-mesh-wwg-hat.2621315a.png";